import React, { useState, useEffect } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';
import MomentUtils from '@date-io/moment';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import { SearchOutlined, Clear, KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import {
  DATE_FRONT_FORMAT,
  DATE_SERVER_FORMAT,
  DATE_AFTER_SHOW,
  DOUBLE_SPACE_KEY_CODE
} from './../../libraries/constants';
import { handleEnter, isBefore, removeSpaces } from './../../libraries/utils';
import { Search as styles } from './styles';
import 'moment/locale/es';
import { Typography } from '@material-ui/core';

const Search = props => {
  const { classes, setFilteredData, search, isAdvancedDateFilter } = props;
  const [searchText, setSearchText] = useState(search.filter ? search.filter : '');
  const [initialDate, setInitialDate] = useState(
    search.start ? moment(search.start, DATE_FRONT_FORMAT) : null
  );
  const [finalDate, setFinalDate] = useState(
    search.end ? moment(search.end, DATE_FRONT_FORMAT) : null
  );

  const [openSecondDate, setOpenSecondDate] = useState(false);
  const [advancedSearching, setAdvancedSearching] = useState(false);
  const [showRemoveSearch, setShowRemoveSearch] = useState(false);
  const [showEndMessage, setShowEndMessage] = useState(false);
  const [isDoubleSpace, setIsDoubleSpace] = useState(false);
  useEffect(() => {
    const isThereFields = initialDate && finalDate;
    const isB = isBefore(finalDate, initialDate);

    if (!isThereFields || !isB) {
      return;
    }
    searchHandle(true)();
  }, [initialDate, finalDate]);

  useEffect(() => {
    if (initialDate) {
      if (finalDate) {
        const isB = isBefore(finalDate, initialDate);

        if (!isB) {
          setShowEndMessage(true);
          setFinalDate(null);
        }
      } else {
        setShowEndMessage(true);
      }
      setOpenSecondDate(true);
    }
  }, [initialDate]);

  useEffect(() => {
    if (!finalDate && initialDate) {
      setShowEndMessage(true);
    } else {
      setShowEndMessage(false);
    }
  }, [finalDate]);

  useEffect(() => {
    if (!showRemoveSearch) {
      searchHandle(true)();
    }
  }, [showRemoveSearch]);

  const handleChange = event => {
    const { value } = event.target;
    let newValue = value;
    if (value.length > 0) {
      setSearchText('');
      setShowRemoveSearch(true);
    }
    if (isDoubleSpace) {
      setIsDoubleSpace(false);
      const pos = newValue.lastIndexOf('.');
      if (pos >= 0) {
        newValue = newValue.substring(0, pos) + ' ';
      }
    }

    setSearchText(removeSpaces(newValue));
  };

  const removeSearch = async event => {
    setSearchText('');
    setShowRemoveSearch(false);
  };

  const handleClickAdvancedSearching = async event => {
    setAdvancedSearching(!advancedSearching);
    if (advancedSearching) {
      const valueDate = true && initialDate && finalDate;
      await setFinalDate(null);
      await setInitialDate(null);
      setShowEndMessage(false);
      setOpenSecondDate(false);

      if (valueDate) {
        await searchHandle(false)();
      }
    }
  };

  const searchHandle = (withDates = false) => event => {
    const filterInformationArr = [];

    if (searchText.length >= 0) {
      filterInformationArr.push(`filter=${searchText ? searchText.trim() : ''}`);
    }

    if (initialDate && finalDate && withDates) {
      filterInformationArr.push(
        `start=${
          initialDate ? moment(initialDate, DATE_FRONT_FORMAT).format(DATE_SERVER_FORMAT) : ''
        }`
      );

      filterInformationArr.push(
        `end=${finalDate ? moment(finalDate, DATE_FRONT_FORMAT).format(DATE_SERVER_FORMAT) : ''}`
      );
    }
    setFilteredData(filterInformationArr.join('&'));
  };

  const calendarModalProps = {
    variant: 'outlined',
    margin: 'normal',
    format: DATE_FRONT_FORMAT,
    okLabel: 'Aceptar',
    cancelLabel: 'Cancelar',
    clearLabel: 'Limpiar',
    todayLabel: 'hoy',
    autoOk: true,
    InputLabelProps: {
      shrink: true
    }
  };
  const removeDotInDoubleSpace = event => {
    const { keyCode } = event;
    if (keyCode === DOUBLE_SPACE_KEY_CODE) {
      setIsDoubleSpace(true);
    }
    return event;
  };
  return (
    <div className={classes.searchContainer}>
      <TextField
        variant="outlined"
        id="search"
        className={classNames(classes.margin, classes.textField)}
        type={'text'}
        floatingLabelText="From"
        placeholder="Buscar"
        value={searchText}
        onChange={handleChange}
        onKeyDown={e => handleEnter(searchHandle(true))(removeDotInDoubleSpace(e))}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Tooltip title="Buscar" placement="top">
                <IconButton onClick={searchHandle(true)}>
                  <SearchOutlined />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <React.Fragment>
                {showRemoveSearch && searchText.trim().length > 0 ? (
                  <Tooltip title="Borrar búsqueda" placement="top">
                    <IconButton onClick={removeSearch}>
                      <Clear />
                    </IconButton>
                  </Tooltip>
                ) : (
                  ''
                )}
                {isAdvancedDateFilter ? (
                  <Tooltip title="Búsqueda por fecha" placement="top">
                    <IconButton onClick={handleClickAdvancedSearching}>
                      {advancedSearching ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                  </Tooltip>
                ) : (
                  ''
                )}
              </React.Fragment>
            </InputAdornment>
          )
        }}
      />
      <Collapse
        timeout={800}
        in={advancedSearching}
        className={classNames(classes.collapseContainer)}
      >
        <MuiPickersUtilsProvider utils={MomentUtils} locale={'es'} moment={moment}>
          <Grid container className={classNames(classes.grid)} justify="space-between">
            <DatePicker
              {...calendarModalProps}
              label="Desde"
              className={classNames(classes.datePickerContainer)}
              value={initialDate}
              onChange={setInitialDate}
              disableFuture={true}
            />

            {openSecondDate ? (
              <React.Fragment>
                <DatePicker
                  {...calendarModalProps}
                  label="Hasta"
                  className={classNames(classes.datePickerContainer)}
                  value={finalDate}
                  InputProps={{
                    disabled: false
                  }}
                  minDate={initialDate}
                  dateDisabled={false}
                  onChange={setFinalDate}
                  disableFuture={true}
                />
                {showEndMessage ? (
                  <Typography
                    className={classNames(classes.messageEndDate, classes.errorMessages)}
                    gutterBottom
                  >
                    {DATE_AFTER_SHOW}
                  </Typography>
                ) : (
                  ''
                )}
              </React.Fragment>
            ) : (
              <DatePicker
                {...calendarModalProps}
                label="Hasta"
                InputProps={{
                  disabled: true
                }}
                onChange={() => ''}
                value={null}
                disablePast={true}
                onClick={e => {
                  e.stopPropagation();
                }}
                disableFuture={true}
                dialog={false}
                dateDisabled={true}
                className={classNames(classes.datePickerContainer)}
              />
            )}
          </Grid>
        </MuiPickersUtilsProvider>
      </Collapse>
    </div>
  );
};

Search.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Search);
